<template>
  <div>
    <HeaderView></HeaderView>
    <div class="image-container position-relative">
      <img
        src="/staticImages/banner(gallery).png"
        class="img-fluid h-50"
        alt="Contact Image"
        style="filter: brightness(50%)"
      />
      <div
        class="text-center text-white position-absolute top-50 start-50 translate-middle"
      >
        <h1>GALLERY</h1>
        <p>Home > Gallery</p>
      </div>
    </div>

    <div class="container my-5">
      <div class="row">
        <div
          class="col-lg-4 img-fluid my-4"
          v-for="(image, index) in images"
          :key="index"
        >
          <!-- Button to trigger modal -->
          <b-button @click="showModal(image.id)">
            <img
              :src="image.image"
              alt=""
              class="img-fluid"
              style="height: 300px"
            />
          </b-button>
        </div>
      </div>

      <!-- Modal component -->
      <b-modal
        v-model="isModalVisible"
        :title="`Image Details`"
        @hide="hideModal"
        hide-footer
      >
        <img
          v-if="modalData.image"
          :src="modalData.image"
          alt="Selected image"
          class="img-fluid"
        />
      </b-modal>
    </div>

    <FooterView></FooterView>
  </div>
</template>

<script>
import axios from "axios";
import FooterView from "./Layouts/FooterView.vue";
import HeaderView from "./Layouts/HeaderView.vue";

export default {
  name: "GalleryView",
  components: { HeaderView, FooterView },
  data() {
    return {
      BaseUrl: process.env.VUE_APP_BASE_URL,
      images: {},
      isModalVisible: false,
      modalData: {},
    };
  },
  methods: {
    async getAllGalleries() {
      try {
        const response = await axios.get(`${this.BaseUrl}/galleries`);
        this.images = response.data.data;
        console.log(this.images);
      } catch (error) {
        console.error("Error fetching gallery data:", error);
      }
    },
    async showModal(imageID) {
      this.isModalVisible = true;
      try {
        const response = await axios.get(
          `${this.BaseUrl}/galleries/${imageID}`
        );
        this.modalData = response.data.data;
        console.log(this.modalData);
      } catch (error) {
        console.error("Error fetching image details:", error);
        this.modalData = {};
      }
    },
    hideModal() {
      this.isModalVisible = false; // Hide the modal
    },
  },
  mounted() {
    this.getAllGalleries();
    document.title = "Gallery - Mandalay Water Boom";
  },
};
</script>
